import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getClasses } from "../../../store/actions/class";
import { useRouter } from 'next/router';
import Link from 'next/link';
import { getLearnWorldUrl } from "../../../api/learn_worlds";

import AppClasses from '../../../../src/components/app/classes';
// import "./style.scss";

function LibraryContent() {
	// const [isLogin, setIsLogin] = useState(false);
	// const router = useRouter();
	// const dispatch = useDispatch();
	// const { classes, loadingClasses, user } = useSelector((state) => ({
	// 	classes: state.classReducer.classes,
	// 	loadingClasses: state.classReducer.loadingClasses,
	// 	user: state.userAuth,
	// }), shallowEqual);

	// const [localClasses, setlLocalClasses] = useState([]);
	// const [filter, setFilter] = useState({ all: true, free: false, preminum: false });

	// useEffect(() => {
	// 	if (user.authenticated && user.token) {
	// 		setIsLogin(true);
	// 	}
	// 	dispatch(getClasses());
	// }, []);

	// useEffect(() => {
	// 	setlLocalClasses(classes);
	// 	if (window.innerWidth < 767) {
	// 		filterClasses('free');
	// 	}
	// }, [classes]);

	// const filterClasses = (category) => {
	// 	switch (category) {
	// 		case "all":
	// 			setlLocalClasses(classes);
	// 			setFilter({ all: true, free: false, preminum: false });
	// 			break;
	// 		case "free":
	// 			setlLocalClasses(classes.filter((cls) => {
	// 				if (cls.course_category === "free") {
	// 					return cls;
	// 				}
	// 			}));
	// 			setFilter({ all: false, free: true, preminum: false });
	// 			break;
	// 		case "premium":
	// 			setlLocalClasses(classes.filter((cls) => {
	// 				if (cls.course_category === "premium") {
	// 					return cls;
	// 				}
	// 			}));
	// 			setFilter({ all: false, free: false, preminum: true });
	// 			break;
	// 		default:
	// 			break;
	// 	}
	// }

	// const openIframe = (data) => {
	// 	if (data) {
	// 		// router.push('/home/course-library', `/course-library?title=${data.title.replace(/\ /g, '_')}`, { shallow: true });
	// 		router.push('/home/course-library', `/course-library/?id=${data.id}`, { shallow: true });
	// 	}
	// }

	// const handleCourseButton = (event) => {
	// 	event.target.firstElementChild.classList.remove('hidden');
	// 	getLearnWorldUrl().then((res) => {
	// 		if (res.success) {
	// 			let aaa = res.url;
	// 			window.open(res.url);
	// 			event.target.firstElementChild.classList.add('hidden');
	// 		}
	// 	});

	// 	// if (learnWorlds!=null) {
	// 	//   router.push(`${learnWorlds}`, `${learnWorlds}`, {
	// 	//     shallow: true,
	// 	//   });
	// 	// }

	// }

	return (
		<AppClasses/>
		// <>
		// 	<div className="content network-block classes-block classes-page logout-library">
		// 		<div className="wrapper">
		// 			<div className="row">
		// 				<div className="col col-md-8 margin-auto">
		// 					<div className="my-conection">
		// 						<h1><strong>Bayan On-Demand Classes</strong></h1>
		// 						<div className="conection-list mobile-only">
		// 							<ul className="library-btns">
		// 								<li className={filter.free ? 'selected' : ''}>
		// 									<a onClick={() => filterClasses("free")}><img src={`/icons/cash.png`} width="16" className="mr-2" /> Free</a>
		// 								</li>
		// 								<li className={filter.preminum ? 'selected' : ''}>
		// 									<a onClick={() => filterClasses("premium")}><img src={`${process.env.IMAGES_BASE_URL}/static-content/noun_premium_488913.png.webp`} width="16" className="mr-2" /> Premium</a>
		// 								</li>
		// 							</ul>
		// 						</div>
		// 						<div className="row">
		// 							{!loadingClasses ?
		// 								localClasses.map((cls) => {
		// 									return (
		// 										<div className="col-md-3a" key={cls.id}>
		// 											<div className="card card-vertical">
		// 												<div className="st-list">
		// 													<div className="st-in st-left">
		// 														<div className="class-image"><img src={`${cls.thumbnail}.webp`} alt="network-icon" /></div>
		// 														<div className="class-body">
		// 															<label>{cls.title}</label>
		// 															<p>{cls.description}</p>
		// 															{/* <a target="_blank" href="https://www.bayanonline.org/offers/LtXd2L9g/checkout" className={`btn-in ${cls.course_category == "free" ? 'btn-green' : 'btn-yellow'}`}>View Course</a> */}
		// 															{isLogin ?
																		
		// 																<a className={`btn-in ${cls.course_category == "free" ? 'btn-green' : 'btn-yellow'}`} onClick={(e) => { handleCourseButton(e) }}>
		// 																	View Course
		// 																	<img className="hidden" src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px' }} />
		// 																</a>
		// 																 : 
		// 																<Link href={{
		// 																	pathname: '/register',
		// 																	query: { isSubscribe: true },
		// 																}} as='/register'>
		// 																	<a className={`btn-in ${cls.course_category == "free" ? 'btn-green' : 'btn-yellow'}`}>Subscribe</a>
		// 																</Link>
		// 															}
		// 														</div>
		// 													</div>
		// 												</div>
		// 											</div>
		// 										</div>)
		// 								}) : <></>
		// 							}
		// 						</div>
		// 						{loadingClasses ? <span className="like-loader" style={{ display: 'flex', marginTop: '100px' }}><img src={`${process.env.IMAGES_BASE_URL}/static-content/general-loading.gif`} style={{ height: '100px', margin: '0 auto', }} /></span> : <></>}
		// 					</div>
		// 				</div>
		// 			</div>
		// 		</div>
		// 	</div>
		// </AppClasses>
	);
}

export default LibraryContent;
